import React from 'react';

import Header from '../partials/Header';
import AboutUsIntro from '../partials/AboutUsIntro';
import Team from '../partials/Team';
import Clients from '../partials/Clients';
import Footer from '../partials/Footer';
import EnvironmentalPolicy from "../partials/EnvironmentalPolicy";

function About() {
    return (
        <div className="flex flex-col min-h-screen overflow-hidden bg-black">
            <Header />

            <main className="flex-grow relative">
                <div
                    className="pointer-events-none absolute inset-0"
                    aria-hidden="true"
                    style={{
                        background:
                            'radial-gradient(circle at top left, rgba(59,130,246,0.20), transparent 55%),' +
                            'radial-gradient(circle at top right, rgba(23, 204, 224, 0.1), transparent 55%),' +
                            'radial-gradient(circle at bottom center, rgba(16,185,129,0.18), transparent 60%)',
                        
                    }}
                />

                <div className="relative">


                    <AboutUsIntro />
                    <Team />
                    <EnvironmentalPolicy />
                    <Clients />
                </div>
            </main>

            {/*  Site footer */}
            <Footer />
        </div>
    );
}

export default About;
